function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.62 0a1.14 1.14 0 00-1.133 1.134v1.902H1.133A1.14 1.14 0 000 4.17c0 .632.522 1.133 1.133 1.133h.482l1.877 15.691c.055.583.564 1.006 1.13 1.006h12.755a1.15 1.15 0 001.13-.994v-.002l1.878-15.7h.482A1.14 1.14 0 0022 4.17a1.14 1.14 0 00-1.133-1.134h-5.354V1.134A1.14 1.14 0 0014.38 0H7.62zm1.132 2.268h4.495v.768H8.752v-.768zM3.904 5.303h14.192L16.38 19.75H5.622L3.904 5.303z",
    fill: props.fill
  }));
};
export default SvgTrash;